"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMReportId = void 0;
var EMReportId;
(function (EMReportId) {
    EMReportId["StudentLevelReport"] = "em-student-level-report";
    EMReportId["SummaryReport"] = "em-summary-report";
    EMReportId["ParticipationReport"] = "em-participation-report";
    EMReportId["StandardReport"] = "em-standard-report";
})(EMReportId || (exports.EMReportId = EMReportId = {}));
//# sourceMappingURL=em-report-id.enum.js.map